import { Box } from "@mui/material";
import EmptyState from "../../components/emptyStates/emptyState.component";
import FieldNotebookTab from "../../components/muiTabs/fieldNotebookTab/fieldNoteBookTab.component";
import { useEffect, useState } from "react";
import { useIsMobile } from "../../hook/useIsMobile";
import { useNavigate, useSearchParams } from "react-router";
import FieldNoteContent from "../../components/fieldNoteContent/fieldNoteContent.component";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldsStart } from "../../store/features/customer/fields/fieldsSlice";
import { fetchDiseasesStart } from "../../store/features/diseases/diseasesSlice";
import { fetchFieldNotesStart } from "../../store/features/fieldNotes/fieldNotesSlice";

function groupNotesByField(notes) {
  const grouped = {};

  notes?.forEach((note) => {
    const fieldId = note.field?.id;

    if (!grouped[fieldId]) {
      grouped[fieldId] = {
        fieldId: note.field?.id,
        fieldName: note.field?.name,
        notesForField: 0,
      };
    }
    grouped[fieldId].notesForField += 1;
  });

  return Object.values(grouped);
}

const FieldNotebookPage = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [hasActiveFilters, setHasActiveFilter] = useState(false);

  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const fieldNotes = useSelector((state) => state.fieldNotes?.data?.data);

  const fieldsWithNotes = groupNotesByField(fieldNotes);
  const selectedFieldParam = searchParams.get("fieldId");
  const selectedTabByFieldId = fieldsWithNotes.findIndex(
    (field) => field.fieldId === selectedFieldParam,
  );
  const selectedTab = selectedTabByFieldId >= 0 ? selectedTabByFieldId : 0;
  const selectedFieldId = fieldsWithNotes[selectedTab]?.fieldId;

  const filteredNotes = fieldNotes?.filter(
    (note) => note.field?.id === selectedFieldId,
  );
  const showEmptyState = fieldNotes?.length === 0 && !hasActiveFilters;
  const showEmptyFilterResult = fieldNotes?.length === 0 && hasActiveFilters;

  useEffect(() => {
    if (!accessToken) return;

    dispatch(fetchFieldsStart({ accessToken }));
    dispatch(fetchDiseasesStart());
    dispatch(fetchFieldNotesStart());
  }, [accessToken, dispatch]);

  const handleTabChange = (newValue) => {
    const nextFieldId = fieldsWithNotes[newValue]?.fieldId;
    const nextSearchParams = new URLSearchParams(searchParams);

    if (nextFieldId) {
      nextSearchParams.set("fieldId", nextFieldId);
    } else {
      nextSearchParams.delete("fieldId");
    }

    setSearchParams(nextSearchParams, { replace: true });
  };

  return (
    <>
      {showEmptyState ? (
        <EmptyState
          text={"Non hai ancora nessuna nota nel taccuino"}
          buttonLabel={"Nuova nota"}
          href={"/fieldNotebook/addNote"}
          navigate={navigate}
        />
      ) : (
        <Box display="flex" flexDirection="column" width="100%" height="100%">
          <FieldNotebookTab
            value={selectedTab}
            onChange={handleTabChange}
            tabs={fieldsWithNotes}
          />
          <FieldNoteContent
            isMobile={isMobile}
            filteredNotes={filteredNotes}
            onFiltersChange={setHasActiveFilter}
            showEmptyFilterResult={showEmptyFilterResult}
          />
        </Box>
      )}
    </>
  );
};

export default FieldNotebookPage;
